(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3707],{

/***/ 63279:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/customizing-products",
      function () {
        return __webpack_require__(33253);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customizing_products; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./components/customizing/customizingProducts/Customizing.styles.js
var Customizing_styles = __webpack_require__(85140);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./api/packagingBasket.js
var packagingBasket = __webpack_require__(38172);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var react_redux_es = __webpack_require__(64384);
// EXTERNAL MODULE: ./api/packaging.js
var packaging = __webpack_require__(82313);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 91 modules
var swiper_esm = __webpack_require__(8701);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./store/useBannerStore.js
var useBannerStore = __webpack_require__(13880);
;// CONCATENATED MODULE: ./components/customizing/customizingProducts/CustomizingSlider.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var CustomizingSlider = function(param) {
    var banners = param.banners;
    var ref = (0,useBannerStore/* useBannerStore */.Q)(function(s) {
        return s;
    }), customLg = ref.customLg, customSm = ref.customSm;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: customLg && customSm && customLg.length > 0 && customSm.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* CustomizingSliderSection */.KZ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* LeftBigBanner */.jb, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            slidesPerView: 1,
                            autoplay: true,
                            loop: customLg && customLg.length > 1,
                            navigation: {
                                prevEl: ".custom_prev_leftBig",
                                nextEl: ".custom_next_leftBig"
                            },
                            className: "custom-class",
                            initialSlide: 1,
                            children: customLg && customLg.map(function(el, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* LeftBigSlide */.qU, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: el.link_url,
                                            target: el.new_win === "Y" ? "_blank" : "_self",
                                            className: "P",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: el.P_FileUrl,
                                                alt: el.img_alt
                                            })
                                        })
                                    })
                                }, i);
                            })
                        }),
                        customLg && customLg.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "slider-arrow",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "slider-btn slider-prev slick-arrow custom_prev_leftBig",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-angle-left"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "slider-btn slider-next slick-arrow custom_next_leftBig",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-angle-right"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* RightSmallBanner */.oq, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            slidesPerView: 1,
                            autoplay: true,
                            loop: customSm && customSm.length > 1,
                            navigation: {
                                prevEl: ".custom_prev_rightSmall",
                                nextEl: ".custom_next_rightSmall"
                            },
                            className: "custom-class",
                            initialSlide: 1,
                            children: customSm && customSm.map(function(el, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* RightSmallSlide */.iJ, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: el.link_url,
                                            target: el.new_win === "Y" ? "_blank" : "_self",
                                            className: "P",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: el.P_FileUrl,
                                                alt: el.img_alt
                                            })
                                        })
                                    })
                                }, i);
                            })
                        }),
                        customSm && customSm.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "slider-arrow",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "slider-btn slider-prev slick-arrow custom_prev_rightSmall",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-angle-left"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "slider-btn slider-next slick-arrow custom_next_rightSmall",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-angle-right"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* MobileBanner */.BR, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        slidesPerView: 1,
                        autoplay: true,
                        loop: true,
                        className: "custom-class",
                        initialSlide: 0,
                        children: _toConsumableArray(customLg).concat(_toConsumableArray(customSm)).map(function(el, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* LeftBigSlide */.qU, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: el.link_url,
                                        target: el.new_win === "Y" ? "_blank" : "_self",
                                        className: "M",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: el.M_FileUrl,
                                            alt: el.img_alt
                                        })
                                    })
                                })
                            }, i);
                        })
                    })
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        banners: state.banners
    };
};
/* harmony default export */ var customizingProducts_CustomizingSlider = ((0,react_redux_es/* connect */.$j)(mapStateToProps, null)(CustomizingSlider));

// EXTERNAL MODULE: ./components/customizing/customizingProducts/CustomizingCate.js
var CustomizingCate = __webpack_require__(30075);
// EXTERNAL MODULE: ./components/customizing/customizingProducts/PortfolioSlider.js
var PortfolioSlider = __webpack_require__(42682);
// EXTERNAL MODULE: ./common/splicePrice.js
var splicePrice = __webpack_require__(8025);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./components/customizing/customizingProducts/Customizing.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





















var CustomizingProducts = function(param) {
    var _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$closeConfirmModal = param.closeConfirmModal, _$isLoading = param.isLoading, _$isLoaded = param.isLoaded, userInfo = param.userInfo, dummyList = param.dummyList;
    var ref3;
    var router = (0,next_router.useRouter)();
    var customRef = (0,react.useRef)([]);
    // 유저 여부
    var isUser = (0,react.useMemo)(function() {
        var ref;
        if (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey) {
            return true;
        } else {
            return false;
        }
    }, [
        userInfo
    ]);
    // 유저 여부
    // 견적 바구니
    var ref1 = (0,react.useState)([]), basketData = ref1[0], setBasketData = ref1[1];
    // 제작사례 & 포장재리뷰 리스트
    var ref2 = (0,react.useState)([]), gallery = ref2[0], setGallery = ref2[1];
    // 제작사례 & 포장재리뷰 불러오기
    var fetchGallery = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "GalleryListSet"
                        };
                        _ctx.next = 3;
                        return (0,packaging/* PackagingApi */.Ri)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            setGallery((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Data);
                        } else {
                            ;
                            console.error(res === null || res === void 0 ? void 0 : (ref4 = res.Data) === null || ref4 === void 0 ? void 0 : ref4.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchGallery() {
            return _ref.apply(this, arguments);
        };
    }();
    // 장바구니 리스트 불러오기
    var fetchCustomBasket = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 3;
                        return (0,packagingBasket/* PackagingListSet */.tP)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            setBasketData(res.Data);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchCustomBasket() {
            return _ref.apply(this, arguments);
        };
    }();
    // 장바구니 삭제
    var deleteBasketItem = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee1(id) {
            var content;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        content = {
                            title: "\uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                            actionBtnLabel: "\uD655\uC778",
                            actionBtnValid: true,
                            cancelBtnLabel: "\uCDE8\uC18C",
                            onAction: _asyncToGenerator(runtime_default().mark(function _callee() {
                                var body, res;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            body = {
                                                modes: "DeleteSet",
                                                id: id
                                            };
                                            _ctx.next = 3;
                                            return (0,packagingBasket/* PackagingDeleteSet */.$8)(body);
                                        case 3:
                                            res = _ctx.sent;
                                            if (res.Code === "0000") {
                                                (0,common_alert/* successAlert */.Cq)("\uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                                                fetchCustomBasket();
                                                _$closeConfirmModal();
                                            } else {
                                                (0,common_alert/* failAlert */.qh)("\uC0AD\uC81C\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                                            }
                                        case 5:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        };
                        _$modifyConfirmModal(content);
                        _$openConfirmModal();
                    case 3:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function deleteBasketItem(id) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchGallery();
        fetchCustomBasket();
    }, []);
    // 페이지 타이틀 동적 설정
    var getPageTitle = function() {
        // 기본값 설정
        var title = SeoMeta/* SeoMeta.estimateRequest.title */.e.estimateRequest.title;
        if (dummyList && dummyList.make_category) {
            var code = router.query.code;
            var first = router.query.first;
            var firstName = first && dummyList.make_category[first];
            var codeName = code && dummyList.make_category[code];
            if (firstName && codeName) {
                // first와 code 둘 다 있으면 'first, code'
                title = "".concat(firstName, ", ").concat(codeName);
            } else if (codeName) {
                // code만 있으면 code
                title = codeName;
            } else if (firstName) {
                // first만 있으면 first
                title = firstName;
            }
        }
        return title;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            noBreadcrumb: "d-none",
            parent: "\uD648",
            sub: "\uB9DE\uCDA4\uC81C\uC791",
            subTitle: "\uACAC\uC801\uC694\uCCAD",
            pageTitle: getPageTitle(),
            pageDesc: SeoMeta/* SeoMeta.estimateRequest.description */.e.estimateRequest.description,
            pageKeyword: SeoMeta/* SeoMeta.estimateRequest.keywords */.e.estimateRequest.keywords,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* Container */.W2, {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* Wrapper */.im, {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(customizingProducts_CustomizingSlider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* CustomCartWrapper */.xz, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    onClick: function() {
                                        router.push(isUser ? "/customizing/customizing-cart" : "/login");
                                    },
                                    children: "\uB098\uC758 \uACAC\uC801\uBC14\uAD6C\uB2C8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cart",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: isUser ? " \uD604\uC7AC \uACAC\uC801 \uBC14\uAD6C\uB2C8\uC5D0 ".concat((basketData === null || basketData === void 0 ? void 0 : basketData.Count) || 0, "\uAC1C\uC758 \uACAC\uC801\uC774 \uB2F4\uACA8\uC788\uC2B5\uB2C8\uB2E4.") : "\uB85C\uADF8\uC778 \uC2DC \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "icon",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fi-rs-shopping-bag"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "bag-count",
                                                    children: (basketData === null || basketData === void 0 ? void 0 : basketData.Count) || 0
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "hover-cart",
                                            children: [
                                                basketData === null || basketData === void 0 ? void 0 : (ref3 = basketData.Rows) === null || ref3 === void 0 ? void 0 : ref3.map(function(el, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "cart-row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "cart-tumbnail",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: el.image
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                        children: el.name
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "cart-info",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info-box",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "\uC218\uB7C9 :"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: (0,splicePrice/* priceComma */.a)(el.cnt)
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "\uB2E8\uAC00 :"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: el.price === "0" ? "24\uC2DC\uAC04 \uC774\uB0B4 \uACAC\uC801" : (0,splicePrice/* priceComma */.a)(el.price) + "\uC6D0"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "\uD569\uACC4 :"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: el.price === "0" ? "24\uC2DC\uAC04 \uC774\uB0B4 \uACAC\uC801" : (0,splicePrice/* priceComma */.a)(Number(el.cnt) * Number(el.price)) + "\uC6D0"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "btn-box",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            className: "btn btn-sm btn-danger",
                                                                            onClick: function() {
                                                                                return deleteBasketItem(el.id);
                                                                            },
                                                                            children: "\uC0AD\uC81C"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, i);
                                                }),
                                                !isUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex flex-column",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                color: "#212529",
                                                                textAlign: "center",
                                                                marginBottom: "10px"
                                                            },
                                                            children: "\uB85C\uADF8\uC778\uC774 \uD544\uC694\uD55C \uAE30\uB2A5\uC785\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/login",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "btn btn-sm",
                                                                children: "\uB85C\uADF8\uC778"
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-btn",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/customizing/customizing-cart",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "btn btn-sm",
                                                            children: "\uACAC\uC801 \uBC14\uAD6C\uB2C8\uB85C \uC774\uB3D9"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizingCate/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioSlider/* default */.Z, {
                            gallery: gallery
                        })
                    ]
                })
            })
        })
    });
};
var Customizing_mapStateToProps = function(state) {
    return {
        userInfo: state.userInfo,
        dummyList: state.dummyList
    };
};
var mapDispatchToProps = {
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k
};
/* harmony default export */ var Customizing = ((0,react_redux_es/* connect */.$j)(Customizing_mapStateToProps, mapDispatchToProps)(CustomizingProducts));

;// CONCATENATED MODULE: ./pages/customizing/customizing-products/index.js


function CustomizingProductsPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing, {})
    });
}
/* harmony default export */ var customizing_products = (CustomizingProductsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,2511,4027,711,9774,2888,179], function() { return __webpack_exec__(63279); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);